<template>
  <div>
    <Registerlayout>
      <div class="container" v-if="!getotp">
        <form @submit.prevent="resetpassword()">
          <h5 class="text-center">Forget Password</h5>
          <div class="form-group">
            <label>Email</label> <i class="icon_mail_alt"></i>
            <input type="email" class="form-control" v-model="email" />
          </div>

          <button
            type="submit"
            class="btn_1 rounded full-width"
            :disabled="loading"
          >
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            Reset Password
          </button>
        </form>
      </div>
      <div class="container" v-if="getotp">
        <form @submit.prevent="checkotp()">
          <h5>Check your email!</h5>
          <div class="form-group">
            <label
              >We’ve sent a Five-digit confirmation code to
              <strong class="text-bold">{{ email }}.</strong> Enter it below to
              rest your passsword.</label
            >
            <input
              type="text"
              class="form-control mt-3"
              placeholder="Enter OTP"
              v-model="otp"
            />
            <input
              type="text"
              class="form-control mt-3"
              placeholder="Enter New Password"
              v-model="password"
            />
          </div>

          <button
            type="submit"
            class="btn_1 rounded full-width"
            :disabled="loading"
          >
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            Change Password
          </button>
        </form>
      </div>
    </Registerlayout>
  </div>
</template>

<script>
import API from "../services/index";
import Registerlayout from "../layouts/Registerlayout.vue";
//import router from "../routes";

export default {
  data() {
    return {
      loading: false,
      getotp: false,
      email: "",
      otp: null,
      password: "",
    };
  },
  components: {
    Registerlayout,
  },
  methods: {
    resetpassword() {
      this.loading = true;
      const form = new FormData();
      form.append("email", this.email);
      API.post(`User/forgetpassword`, form)
        .then((res) => {
          if (res.data.status == 200) {
            this.getotp = true;
            this.loading = false;
            this.$swal("Success", res.data.messages);
          } else {
            this.$swal("Error", res.data.messages);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkotp() {
      this.loading = true;
      const form = new FormData();
      form.append("otp", this.otp);
      form.append("password", this.password);
      form.append("email", this.email);
      API.post(`User/checkotp`, form)
        .then((res) => {
          if (res.data.status == 200) {
            this.loading = false;
            this.$swal("Success", res.data.messages);
            this.$router.push("/signin");
          }else{
            this.$swal("Error", res.data.messages);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
